import axios from "axios";
import { API_BASE_URL } from "../../config";

// Ensure we have a clean base URL without duplicate /api
const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

export const getPnLReport = async (filters = {}) => {
  try {
    const response = await axios.get(`${BASE}/reports/pnl`, { params: filters });
    return response.data;
  } catch (error) {
    console.error("Error fetching PnL report:", error);
    throw error;
  }
};

export const getExpenseReport = async (filters = {}) => {
  try {
    const response = await axios.get(`${BASE}/reports/expenses`, { params: filters });
    return response.data;
  } catch (error) {
    console.error("Error fetching Expense report:", error);
    throw error;
  }
};

export const getOutstandingReport = async (filters = {}) => {
  try {
    const response = await axios.get(`${BASE}/reports/outstanding`, { params: filters });
    return response.data;
  } catch (error) {
    console.error("Error fetching Outstanding report:", error);
    throw error;
  }
};
